import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ContentPerformance = ({ title = "Top Performing Content" }) => {
  const [sortBy, setSortBy] = useState('engagement');
  const [timeframe, setTimeframe] = useState('week');

  const mockPosts = [
    {
      id: 1,
      platform: 'instagram',
      content: `Discover the breathtaking beauty of Ooty's tea gardens! 🌿 Our exclusive hill station package includes guided tours, cozy accommodations, and authentic local experiences. Book now for the perfect mountain getaway! #OotyTourism #HillStation #DruTravels`,
      thumbnail: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=300&h=200&fit=crop',
      timestamp: new Date(Date.now() - 86400000),
      metrics: {
        likes: 1247,
        comments: 89,
        shares: 156,
        reach: 15420,
        engagement: 9.7,
        clicks: 234
      },
      hashtags: ['#OotyTourism', '#HillStation', '#DruTravels']
    },
    {
      id: 2,
      platform: 'twitter',content: `🛶 Experience the serene backwaters of Kerala with our all-inclusive package! Traditional houseboat stays, authentic cuisine, and guided nature walks. Limited time offer - 20% off! Book your Kerala adventure today! #KeralaBackwaters #Houseboat #TravelDeals`,thumbnail: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=300&h=200&fit=crop',
      timestamp: new Date(Date.now() - 172800000),
      metrics: {
        likes: 892,
        comments: 45,
        shares: 203,
        reach: 12850,
        engagement: 8.9,
        clicks: 189
      },
      hashtags: ['#KeralaBackwaters', '#Houseboat', '#TravelDeals']
    },
    {
      id: 3,
      platform: 'instagram',
      content: `🏛️ Step back in time at Mahabalipuram! Our heritage tour includes expert guides, UNESCO World Heritage sites, and cultural performances. Perfect for history enthusiasts and families alike! #Heritage #Mahabalipuram #CulturalTour`,
      thumbnail: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=300&h=200&fit=crop',
      timestamp: new Date(Date.now() - 259200000),
      metrics: {
        likes: 756,
        comments: 67,
        shares: 98,
        reach: 9840,
        engagement: 9.4,
        clicks: 145
      },
      hashtags: ['#Heritage', '#Mahabalipuram', '#CulturalTour']
    },
    {
      id: 4,
      platform: 'facebook',
      content: `🏔️ Kodaikanal calling! Our solo traveler package ensures safety, comfort, and amazing connections with fellow adventurers. Includes accommodation, meals, and guided treks. Perfect for your solo journey! #SoloTravel #Kodaikanal #Adventure`,
      thumbnail: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=200&fit=crop',
      timestamp: new Date(Date.now() - 345600000),
      metrics: {
        likes: 634,
        comments: 52,
        shares: 87,
        reach: 8920,
        engagement: 8.7,
        clicks: 167
      },
      hashtags: ['#SoloTravel', '#Kodaikanal', '#Adventure']
    },
    {
      id: 5,
      platform: 'instagram',content: `🌊 Chennai to Pondicherry coastal drive! Experience French colonial architecture, pristine beaches, and spiritual retreats. Our weekend package includes transport, accommodation, and guided tours. #Pondicherry #CoastalDrive #WeekendGetaway`,thumbnail: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=300&h=200&fit=crop',
      timestamp: new Date(Date.now() - 432000000),
      metrics: {
        likes: 523,
        comments: 38,
        shares: 72,
        reach: 7650,
        engagement: 8.3,
        clicks: 134
      },
      hashtags: ['#Pondicherry', '#CoastalDrive', '#WeekendGetaway']
    }
  ];

  const sortedPosts = [...mockPosts].sort((a, b) => {
    if (sortBy === 'engagement') return b.metrics.engagement - a.metrics.engagement;
    if (sortBy === 'reach') return b.metrics.reach - a.metrics.reach;
    if (sortBy === 'likes') return b.metrics.likes - a.metrics.likes;
    return b.metrics.clicks - a.metrics.clicks;
  });

  const getPlatformIcon = (platform) => {
    const icons = {
      instagram: 'Instagram',
      twitter: 'Twitter',
      facebook: 'Facebook'
    };
    return icons[platform] || 'Globe';
  };

  const getPlatformColor = (platform) => {
    const colors = {
      instagram: 'text-pink-500',
      twitter: 'text-blue-500',
      facebook: 'text-blue-600'
    };
    return colors[platform] || 'text-muted-foreground';
  };

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toString();
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const days = Math.floor(diff / 86400000);
    
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    return `${days} days ago`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        
        <div className="flex items-center space-x-2">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="text-sm border border-border rounded-md px-3 py-1 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="engagement">Engagement Rate</option>
            <option value="reach">Reach</option>
            <option value="likes">Likes</option>
            <option value="clicks">Clicks</option>
          </select>
        </div>
      </div>

      <div className="space-y-4">
        {sortedPosts.map((post, index) => (
          <div key={post.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-micro">
            <div className="flex space-x-4">
              <div className="flex-shrink-0">
                <div className="relative">
                  <Image
                    src={post.thumbnail}
                    alt="Post thumbnail"
                    className="w-20 h-20 rounded-lg object-cover"
                  />
                  <div className="absolute -top-2 -left-2 w-6 h-6 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-xs font-bold">
                    {index + 1}
                  </div>
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon 
                    name={getPlatformIcon(post.platform)} 
                    size={16} 
                    className={getPlatformColor(post.platform)}
                  />
                  <span className="text-sm text-muted-foreground">
                    {formatTimestamp(post.timestamp)}
                  </span>
                </div>
                
                <p className="text-sm text-foreground mb-3 line-clamp-3 leading-relaxed">
                  {post.content}
                </p>
                
                <div className="flex flex-wrap gap-1 mb-3">
                  {post.hashtags.map((tag, tagIndex) => (
                    <span 
                      key={tagIndex}
                      className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 text-sm">
                  <div className="text-center">
                    <div className="font-semibold text-foreground">{formatNumber(post.metrics.likes)}</div>
                    <div className="text-muted-foreground text-xs">Likes</div>
                  </div>
                  <div className="text-center">
                    <div className="font-semibold text-foreground">{formatNumber(post.metrics.comments)}</div>
                    <div className="text-muted-foreground text-xs">Comments</div>
                  </div>
                  <div className="text-center">
                    <div className="font-semibold text-foreground">{formatNumber(post.metrics.shares)}</div>
                    <div className="text-muted-foreground text-xs">Shares</div>
                  </div>
                  <div className="text-center">
                    <div className="font-semibold text-foreground">{formatNumber(post.metrics.reach)}</div>
                    <div className="text-muted-foreground text-xs">Reach</div>
                  </div>
                  <div className="text-center">
                    <div className="font-semibold text-success">{post.metrics.engagement}%</div>
                    <div className="text-muted-foreground text-xs">Engagement</div>
                  </div>
                  <div className="text-center">
                    <div className="font-semibold text-foreground">{formatNumber(post.metrics.clicks)}</div>
                    <div className="text-muted-foreground text-xs">Clicks</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 text-center">
        <Button variant="outline" size="sm">
          View All Posts
        </Button>
      </div>
    </div>
  );
};

export default ContentPerformance;